import React from 'react'
import { Helmet } from 'react-helmet'

function Affiliates() {
 return (
  <React.Fragment>
   <Helmet>
    <title>
     Affiliates | Bennabix: Medical Cannabis Discounts & Education
    </title>
    <meta
     name="description"
     content="View Bennabix affiliates and find even more discounts and savings on various cannabis related products and services."
    />
   </Helmet>
   <div className="sectionWrap affiliates">
    <img
     src={require('../assets/images/graphic-01.png')}
     alt=""
     className="backgroundSource"
    />
    <div className="sectionContainer">
      {/* Top Row */}
      <div className="section nuggmd">
        <div className="graphic" style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gridTemplateRows: '1fr 1fr',
          gap: '10px',
          justifyItems: 'center',
          alignItems: 'center',
          backgroundColor: 'white',
          padding: '40px 10px',
        }}>
          <img src={require('../assets/images/affiliates/cmed.png')} alt="cMed" style={{maxWidth: '100%', maxHeight: '150px', height: 'auto'}} />
          <img src={require('../assets/images/affiliates/Elevate.png')} alt="Elevate Holistics" style={{maxWidth: '100%', maxHeight: '150px', height: 'auto'}} />
          <img src={require('../assets/images/affiliates/ezmedcard.png')} alt="EZ Medcard" style={{maxWidth: '100%', maxHeight: '150px', height: 'auto'}} />
          <img src={require('../assets/images/affiliates/NuggMD.png')} alt="NuggMD" style={{maxWidth: '100%', maxHeight: '150px', height: 'auto'}} />
        </div>
        <div className="sectionDetail">
          <span className="heading-01">MEDICAL CANNABIS EVALUATIONS</span>
          <span className="heading-02">
            Get your Medical Cannabis certification at a discount through our affiliates.
          </span>
          <p>
            <a href="/membership-card">
              <strong>Speak with a medical cannabis expert today!</strong>
            </a>
          </p>
        </div>
      </div>
      {/* Middle Row */}
      <div className="section nuggmd">
        <div className="sectionDetail">
          <span className="heading-01">CANNABIS NURSE HOTLINE</span>
          <span className="heading-02">
            Speak with a trained cannabis nurse for guidance.
          </span>
          <p>
            <a href="https://leaf411.org/">
              <strong>Schedule your appointment today!</strong>
            </a>
          </p>
          <p>
            Their mission is to provide education and directional support on the safe use of legal cannabis.
          </p>
        </div>
        <div className="graphic" style={{display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'white', padding: '40px 10px'}}>
          <img src={require('../assets/images/affiliates/leaf411.png')} alt="Leaf411" style={{maxWidth: '100%', maxHeight: '150px', height: 'auto'}} />
        </div>
      </div>
      {/* Tetragram Row */}
      <div className="section nuggmd">
        <div className="graphic" style={{display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'white', padding: '40px 10px'}}>
          <img src="/tetragram.png" alt="Tetragram App" style={{maxWidth: '100%', maxHeight: '150px', height: 'auto'}} />
        </div>
        <div className="sectionDetail">
          <span className="heading-01">TRACK WHAT TREATS</span>
          <span className="heading-02">
            Tetragram App provides a secure journaling tool to track your consumption to help you decode and discover what works best for you and your needs.
          </span>
          <br/>
          <p>
            <span><strong>Available for FREE in the App Store or on Google Play.</strong></span>
          </p>
          <p>
            <a href="https://2ly.link/24MW7" target="_blank" rel="noopener noreferrer">
              <strong>Download the FREE Tetragram App today.</strong>
            </a>
          </p>
        </div>
      </div>
      {/* Americans for Safe Access Row */}
      <div className="section nuggmd">
        <div className="sectionDetail">
          <span className="heading-01">Americans for Safe Access</span>
          <span className="heading-02">
            Founded in 2002, Americans for Safe Access (ASA) is the largest national organization of patients, medical professionals, scientists, providers, and concerned citizens promoting safe and legal access to cannabis for therapeutic use and research. ASA provides medical cannabis stakeholders with educational information, support, and resources for engaging in medical cannabis policy.
          </span>
          <br/>
          <p>
            <span><strong><a href="https://www.safeaccessnow.org/#gsc.tab=0" target="_blank" rel="noopener noreferrer">Join the movement today! Learn more at SafeAccessNow.org</a></strong></span>
          </p>
        </div>
        <div className="graphic" style={{
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          backgroundColor: '#FFFFFF', 
          padding: '40px 10px',
          height: '100%',
          width: '100%'
        }}>
          <img src={require('../assets/images/affiliates/AmericansForSafeAccess.png')} alt="Americans for Safe Access" style={{maxWidth: '100%', maxHeight: '150px', height: 'auto'}} />
        </div>
      </div>
    </div>
   </div>
  </React.Fragment>
 )
}

export default Affiliates
